module.exports = __webpack_public_path__ + "img/lunbo22.b00378e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo22.jpg
// module id = NgrS
// module chunks = 0